import { BaseService } from '@myhealth-raccoon/services';

import { PartialBookingUserWithToken, TokenResponse } from '../auth';
import { customerService } from '../customer';

class CustomerBookingService extends BaseService {
    constructor() {
        super('api/booking', import.meta.env.VITE_CUSTOMER_API_URL);
    }

    get Authorization(): string | undefined {
        return customerService.Authorization;
    }

    public async GetBookingVisitInfo(customerId: number, siteId: number, existingPatient: boolean) {
        return await this.get<PartialBookingUserWithToken>(
            `${customerId}/${siteId}/visits?${new URLSearchParams({ existingPatient: existingPatient.toString() })}`
        );
    }

    public async AuthoriseBookingForCustomer(customerId: number, siteId: number) {
        return await this.get<TokenResponse>(`${customerId}/${siteId}/connect`);
    }
}
export const customerBookingService = new CustomerBookingService();
